import { TFatca } from '~/modules/identification/forms/AdditionalInformation/types.ts';
import { REFUTATION_DOC_TYPE } from '~/modules/identification/forms/AdditionalInformation/constants.ts';

export const parseFullName = (value: string) => {
  const [lastName = '', firstName = '', ...middleNameParts] = value.trim().split(/\s+/);

  return {
    lastName,
    firstName,
    middleName: middleNameParts.join(' '),
  };
};

export const getFatcaForm = (
  values: TFatca,
  showFATCAFop: boolean,
  birthplaceCountryUSA: boolean,
  permanentAddressUSA: boolean,
  citizenshipCountryUSA: boolean
) => {
  if (!showFATCAFop) return null;

  const isUSA = citizenshipCountryUSA || birthplaceCountryUSA || permanentAddressUSA;

  return {
    ...values,
    isForeignFinancialUnderFATCA: values?.isForeignFinancialUnderFATCA,
    fullName: values.isForeignFinancialUnderFATCA ? values.fullName : null,
    fullNameInEng: values.isForeignFinancialUnderFATCA
      ? (values.fullNameInEng?.trim().toUpperCase() ?? null)
      : null,
    tinType: values.isForeignFinancialUnderFATCA ? values.tinType : null,
    tin: values.isForeignFinancialUnderFATCA ? values.tin : null,
    refutationDocType:
      values.isForeignFinancialUnderFATCA === false && isUSA ? values?.refutationDocType : null,
    explanation: {
      usBirthAddress:
        values?.isForeignFinancialUnderFATCA === false &&
        values?.refutationDocType === REFUTATION_DOC_TYPE.EXPLANATION &&
        birthplaceCountryUSA
          ? values?.explanation?.usBirthAddress
          : null,
      message:
        values?.isForeignFinancialUnderFATCA === false &&
        values?.refutationDocType === REFUTATION_DOC_TYPE.EXPLANATION &&
        (birthplaceCountryUSA || permanentAddressUSA)
          ? values?.explanation?.message
          : null,
    },
  };
};
